module.exports = __webpack_public_path__ + "static/media/daenerys.962704b5.jpg";